// Saves a Blob to the user's disk under a given name.
//
// Shared by the generated-document downloads (incident report PDF, DAR PDF), which all follow
// the same shape: fetch the blob, hand it to the browser through a synthetic <a download>.
// Centralized so the filename is sanitized the same way everywhere — a name built from
// user-authored text (an org location label) can contain path separators, and `download`
// handling for those varies by browser.
//
// Mirrors the fold that sage-nest-api's `attachmentDisposition()` applies to the
// Content-Disposition header, so the saved file matches the name the API would have given it.
export const sanitizeDownloadFilename = (filename, fallback = 'download') => {
    const cleaned = String(filename || '')
        // eslint-disable-next-line no-control-regex
        .replace(/[\u0000-\u001f\u007f]/g, ' ')
        // Path separators, plus the characters Windows and macOS reject in a filename.
        .replace(/["\\/:*?<>|]/g, '')
        .replace(/\s+/g, ' ')
        .trim();

    return cleaned || fallback;
};

export const downloadBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = sanitizeDownloadFilename(filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
